var SystemSelectedSlider = {},
  $systemSlider,
  $systemFlkty,
  $systemThumbnailGroup,
  $systemThumbnailGroupItems,
  $systemProductPeview,
  isStatusSystem = false,
  isFlickitySystem = true;
var isOption, isOption2;
var thumbnailOption;
var systemSliderReset = {};
var st;
SystemSelectedSlider.slider = function () {
  $systemSlider = $('.selected-product-system-main-slider');
  $systemThumbnailGroup = $('.selected-product-system-main-thumbnail');
  $systemThumbnailGroupItems = $systemThumbnailGroup.find('.item');
  $thumbnailCount = $('.selected-product-system-main-thumbnail .item').length;
  $systemProductPeview = $('.selected-product-system-main-preview');
  var isIndicator = $systemSlider.children().length > 1 ? true : false;
  $systemSlider.on('ready.flickity', function () {
    $systemProductPeview.removeClass('invisible');
  });
  if ($(window).innerWidth() < 992) {
    isStatusSystem = true;
  } else {
    isStatusSystem = false;
  }
  $systemSlider.flickity({
    pageDots: isStatusSystem,
    contain: true,
    cellAlign: 'left',
    percentPosition: false,
    dragThreshold: 3,
    prevNextButtons: true,
    fullscreen: true,
    selectedAttraction: 0.05,
    friction: 0.28
  });
  isOption = {
    pageDots: isIndicator,
    contain: true,
    cellAlign: 'left',
    percentPosition: false,
    dragThreshold: 3,
    prevNextButtons: true,
    fullscreen: true,
    selectedAttraction: 0.05,
    friction: 0.28
  };
  isOption2 = {
    pageDots: isStatusSystem,
    contain: true,
    cellAlign: 'left',
    percentPosition: false,
    dragThreshold: 3,
    prevNextButtons: true,
    fullscreen: true,
    selectedAttraction: 0.05,
    friction: 0.28
  };
  if ($thumbnailCount > 4) {
    thumbnailOption = {
      asNavFor: '.selected-product-system-main-slider',
      draggable: false,
      percentPosition: false,
      pageDots: false,
      cellAlign: $(window).innerWidth() > 1153 ? 'left' : 'center',
      contain: true,
      groupCells: true,
      dragThreshold: 3,
      selectedAttraction: 0.05,
      friction: 0.28
    };
  } else {
    thumbnailOption = {
      asNavFor: '.selected-product-system-main-slider',
      draggable: false,
      percentPosition: false,
      pageDots: false,
      prevNextButtons: false,
      cellAlign: $(window).innerWidth() > 1153 ? 'left' : 'center',
      contain: true,
      groupCells: true,
      dragThreshold: 3,
      selectedAttraction: 0.05,
      friction: 0.28
    };
  }
  var $sliderThumbnail = $systemThumbnailGroup.flickity(thumbnailOption);
  $systemFlkty = $systemSlider.data('flickity');
  $systemSlider.flickity('resize');

  // update selected cellButtons
  $systemSlider.on('select.flickity', function () {
    $systemThumbnailGroupItems.filter('.is-selected').removeClass('is-selected');
    $systemThumbnailGroupItems.eq($systemFlkty.selectedIndex).addClass('is-selected');
  });
  $(window).resize(function () {
    if ($(window).innerWidth() < 992) {
      isStatusSystem = true;
      systemSliderReset.reInit();
    }
  });

  // select cell on button click
  $systemThumbnailGroup.on('click', '.item', function () {
    var index = $(this).index();
    $systemSlider.flickity('select', index);
  });
  var isThumbnailFlickity = true;
  $systemSlider.on('click', '.item', function () {
    $systemSlider.find('.flickity-fullscreen-button-view').trigger('click');
    if (isThumbnailFlickity) {
      $sliderThumbnail.flickity('destroy');
      isThumbnailFlickity = false;
    }
    st = window.scrollY;
    if (window.innerWidth < 992) {
      document.body.style.overflowY = 'hidden';
      document.body.style.position = 'fixed';
    }
  });
  $systemSlider.on('fullscreenChange.flickity', function (event, isFullscreen) {
    $systemThumbnailGroup.hasClass('is-fullscreen') ? $systemThumbnailGroup.removeClass('is-fullscreen') : $systemThumbnailGroup.addClass('is-fullscreen');
    SystemSelectedSlider.changeImageOnFullscreen($(this), isFullscreen);
    if (!$systemSlider.hasClass('is-fullscreen')) {
      $systemThumbnailGroup.flickity(thumbnailOption);
      isThumbnailFlickity = true;
    }
    if (!$systemThumbnailGroup.hasClass('is-fullscreen')) {
      if (window.innerWidth < 992) {
        document.body.style.overflowY = 'auto';
        document.body.style.position = 'relative';
        $('html, body').animate({
          scrollTop: st
        }, 0);
      }
    }
  });
};
SystemSelectedSlider.changeImageOnFullscreen = function (slider, isFullscreen) {
  var sliderItems = slider.find('.itemer img');
  if (!sliderItems) {
    return;
  }
  sliderItems.each(function () {
    var selectedImage = $(this);
    var src = isFullscreen ? selectedImage.data('full') : selectedImage.data('src');
    selectedImage.attr('src', src);
    if (isFullscreen) {
      slider.attr('style', 'background-color:#303030; transition: all 0s');
    } else {
      slider.attr('style', 'background-color:transparent; transition: all 0s');
    }
  });
};
systemSliderReset.reInit = function () {
  if (matchMedia('screen and (max-width: 991px)').matches) {
    if (isFlickitySystem) {
      $systemSlider.flickity('destroy');
      isFlickitySystem = false;
      $systemSlider.flickity(isOption);
    }
  } else {
    $systemSlider.flickity('destroy');
    $systemSlider.flickity(isOption2);
    isFlickitySystem = true;
  }
};
SystemSelectedSlider.slider();
window.SystemSelectedSlider = SystemSelectedSlider;


// WEBPACK FOOTER //
// ./scripts/components/sliders/product-selected-system.js